import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

interface EditorialTab {
  id: number;
  label: string;
}

interface EditorialTabsProps {
  tabs: EditorialTab[];
  activeId: number | null;
  onChange: (id: number) => void;
}

const EditorialTabs: React.FC<EditorialTabsProps> = ({
  tabs,
  activeId,
  onChange,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        gap: 3,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      {tabs.map((tab) => {
        const isActive = tab.id === activeId;
        return (
          <Box
            key={tab.id}
            onClick={() => onChange(tab.id)}
            sx={{
              cursor: "pointer",
              paddingY: "10px",
              paddingX: "2px",
              borderBottom: `2px solid ${
                isActive ? theme.palette.primary.main : "transparent"
              }`,
              marginBottom: "-1px",
              transition: "border-color 0.15s ease",
              "&:hover": {
                borderBottomColor: isActive
                  ? theme.palette.primary.main
                  : theme.palette.text.tertiary,
              },
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                color: isActive
                  ? theme.palette.primary.main
                  : theme.palette.text.tertiary,
              }}
            >
              {tab.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default EditorialTabs;
